import {
  HttpStatusCodes,
  ApiError,
} from '@loavies/c2c-models'

/**
 * @memberOf loavies.utils.services
 * @constructor
 */
export class ErrorHandlerService {
  constructor() {
  }

  /**
   * @param {Array<Object>} errors
   * @return {Array}
   */
  mapMarketplaceErrors(errors) {
    return errors.map(error => this.mapMarketplaceError(error))
  }

  /**
   * @param {Object} error
   * @return {Error|loavies.models.error.ApiError}
   */
  mapMarketplaceError(error) {
    if (error.status && Object.values(HttpStatusCodes).includes(error.status)) {
      return new ApiError({
        message: this.formatErrorMessage(error),
        messageTranslationKey: error.messageTranslationKey,
        statusCode: error.status,
        details: error.details,
      })
    }

    return Error(error.title)
  }

  /**
   * @param {Object} error
   * @return {string}
   */
  formatErrorMessage(error) {
    let message = error.title

    if (error.source) {
      message += ' ' + this.formatErrorSource(error.source)
    }

    return message
  }

  /**
   * @param {Object} source
   * @return {string}
   */
  formatErrorSource(source) {
    return `"${source.path.join(' > ')}" in ${source.type}`
  }
}
